import React from 'react';

export const AddAccountIcon = () => (
  <svg
    width="31px"
    height="21px"
    viewBox="0 0 31 21"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>add-crd</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g id="add-crd" transform="translate(1.000000, -5.000000)">
        <g id="Icons/Illustrative/AddContact-Copy-3">
          <g id="Icon-/-Illustrative-/-Supplementary-Card-/-30px">
            <g
              id="Supplementary-card-72px"
              transform="translate(0.000000, 5.000000)"
            >
              <g
                id="Group-12"
                transform="translate(0.677083, 0.868056)"
                strokeWidth="1.5"
              >
                <path
                  d="M15.3031488,16.3441051 L0.997184985,16.3441051 C0.446454925,16.3441051 0,15.872008 0,15.2896467 
                  L0,1.05445839 C0,0.472097104 0.446454925,0 0.997184985,0 L22.9352546,0 
                  C23.4859847,0 23.9324396,0.472097104 23.9324396,1.05445839 L23.9324396,5.9241348"
                  id="Rectangle-6"
                  stroke="#CE007C"
                />
                <path
                  d="M3.50230824,9.728634 L14.9131496,9.728634"
                  id="Stroke-409"
                  stroke="#7462E0"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.50230824,12.3229364 L12.0624036,12.3229364"
                  id="Stroke-410"
                  stroke="#7462E0"
                  strokeLinejoin="round"
                />
                <polygon
                  id="Stroke-4"
                  stroke="#BE207A"
                  strokeLinejoin="round"
                  points="3.50230824 7.1343316 7.23302788 7.1343316 7.23302788 3.50230824 3.50230824 3.50230824"
                />
                <path
                  d="M17.5115412,13.4255149 C17.5115412,10.524553 19.8640416,8.17205256 22.7650036,8.17205256 C25.6659655,8.17205256 28.0184659,10.524553 28.0184659,13.4255149 C28.0184659,16.3264768 25.6659655,18.6789773 22.7650036,18.6789773 C19.8640416,18.6789773 17.5115412,16.3264768 17.5115412,13.4255149 L17.5115412,13.4255149 Z"
                  id="Stroke-281"
                  stroke="#042F43"
                  strokeLinejoin="round"
                />
                <path
                  d="M20.5760609,13.4255149 L24.8080167,13.4255149"
                  id="Stroke-283"
                  stroke="#042F43"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.7650036,11.2365723 L22.7650036,15.4685281"
                  id="Stroke-285"
                  stroke="#042F43"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
